import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {WIDGET_DESCRIPTIONS} from '../../components/layout/widget/widget-registry.service';
import {PartialLoadingIndicatorModule} from '../../components/partial-loading-indicator';
import {L10nModule} from '../../components/translate';
import {AutofocusModule} from '../../directives/autofocus';
import {DynAuthWidgetBodyComponent} from '../components/dyn-auth-widget-body/dyn-auth-widget-body.component';
import {DexLpDetailsPartComponent} from '../dex-lp-widget/parts/dex-lp-details-part/dex-lp-details-part.component';
import {DexLpPartPlateComponent} from '../dex-lp-widget/parts/dex-lp-part-plate/dex-lp-part-plate.component';
import {
    DexTrancheDetailsPartComponent
} from '../dex-lp-widget/parts/dex-tranche-details-part/dex-tranche-details-part.component';
import {DexLpCollapsedWidgetComponent} from './dex-lp-collapsed-widget.component';
import {DEX_LP_COLLAPSED_WIDGET_DESCRIPTION} from './dex-lp-collapsed-widget.description';
import {DexLpCollapsedWidgetSettingsComponent} from './settings/dex-lp-collapsed-widget-settings.component';
import {DexLpCollapsedWidgetSettingsService} from './settings/dex-lp-collapsed-widget-settings.service';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        L10nModule,
        AutofocusModule,
        PartialLoadingIndicatorModule,
        DynAuthWidgetBodyComponent,
        DexLpDetailsPartComponent,
        DexTrancheDetailsPartComponent,
        DexLpPartPlateComponent
    ],
    declarations: [
        DexLpCollapsedWidgetComponent,
        DexLpCollapsedWidgetSettingsComponent
    ],
    exports: [
        DexLpCollapsedWidgetComponent
    ],
    providers: [
        DexLpCollapsedWidgetSettingsService,
        {
            provide:  WIDGET_DESCRIPTIONS,
            useValue: DEX_LP_COLLAPSED_WIDGET_DESCRIPTION,
            multi:    true
        }
    ]
})
export class DexLpCollapsedWidgetModule {}
